import { render } from "./FpuiJsonEditor.vue?vue&type=template&id=a6037f8a&lang=pug"
import script from "./FpuiJsonEditor.vue?vue&type=script&lang=js"
export * from "./FpuiJsonEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__